import React from 'react'
import StudentRegister from './StudentRegister/StudentRegister'
import TutorRegister from './TutorRegister/TutorRegister'

const RegisterContent = () => {
    return (

        <div>
            <div className="login-background ">
                {/* <section class="forget-screen-main-secion main-section"> */}
                <div className=" login-main-container ">
                    <div className="row login-form-part">
                        <div className="card login-form">
                            <nav className="nav-butn">
                                <div
                                    style={{ flexWrap: "nowrap", display: "flex" }}
                                    className="nav nav-tabs login-nav login-nav-tabs"
                                    id="nav-tab"
                                    role="tablist"
                                >
                                    <button
                                        className="nav-link login-nav-link active px-1"
                                        id="nav-home-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#nav-home"
                                        type="button"
                                        role="tab"
                                        aria-controls="nav-home"
                                        aria-selected="true"
                                    >
                                        Student Register
                                    </button>
                                    <button
                                        className="nav-link login-nav-link"
                                        id="nav-profile-tab"
                                        data-bs-toggle="tab"
                                        data-bs-target="#nav-profile"
                                        type="button"
                                        role="tab"
                                        aria-controls="nav-profile"
                                        aria-selected="false"
                                    >
                                        Tutor Register
                                    </button>
                                    {/* <button class="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">Contact</button> */}
                                </div>
                            </nav>
                            <div className="tab-content" id="nav-tabContent">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-home"
                                    role="tabpanel"
                                    aria-labelledby="nav-home-tab"
                                >
                                    <StudentRegister />
                                </div>
                                <div
                                    className="tab-pane fade"
                                    id="nav-profile"
                                    role="tabpanel"
                                    aria-labelledby="nav-profile-tab"
                                >
                                    <TutorRegister />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

    )
}

export default RegisterContent